<!-- src/components/ContactsView.vue -->

<template>
    <section class="alerts">
        
        <div class="hidden md:flex pt-2.5 px-0 pb-1">
            <div class="flex-grow">
                <h3 class="tracking-normal text-cal-4A4A4A my-2.5 mx-0 font-bold text-xl">Alerts</h3>
            </div>
            <div class="flex-shrink">
                <vue-button @click="goToSettings">Preferences</vue-button>
            </div>
        </div>

        <div class="alert-list">
            <li v-for="alert in alerts">
                <router-link 
                    v-if="alert.project_id"
                    :to="/Projects/+alert.project.id">
                        {{ alert.message }}
                        <span class="alert-date">{{ alert.created_at | moment("MM/DD/YYYY") }}</span>
                </router-link>
                <router-link 
                    v-if="alert.contact_id"
                    :to="/Contacts/+alert.contact.id">
                        {{ alert.message }}
                        <span class="alert-date">{{ alert.created_at | moment("MM/DD/YYYY") }}</span>
                </router-link>
            </li>
            <div class="alerts-none" 
                v-if="alerts.length <= 0">You have no alerts currently! <router-link to="/Me/Settings">Configure Alert Preferences</router-link></div>
        </div>
    </section>
</template>

<script>

import Vue from 'vue/dist/vue'
import VueButton from '../Shared/VueButton.vue';
import WebServices from '../../services/WebServices';

export default {

    components: { VueButton },
    
    data () {
        return {
            services: WebServices("Alerts"),
            alerts: []
        }
    },
    
    created () {
        this.loadInitial();
    },
    
    methods: {
        
        loadInitial () {
            
            this.getAll()
        },
        
        getAll () {
            this.services.getAll(this.params)
            .then(function(response) {
                this.alerts = response.data.data;
            }.bind(this));
        },
        
        goToSettings () {
            this.$router.push({ name: 'settings' })
        }
    },
    
    watch: {
        '$route': function() {
            this.loadInitial()
        }
    },
}

</script>

<style>
.alert-list {
    border-top: 1px solid #E8E8E8;
}

.alert-list li {
    list-style: none;
    border-bottom: 1px solid #E8E8E8;
}

.alert-list li a {
    text-decoration: none;
    color: #111;
    padding: 15px 100px 15px 20px;
    display: block;
    position: relative;
}

.alert-list li a.new {
    background: #F1F1F1;
}

.alert-list li a:hover {
    background: #F0F0F0;
}

.alert-list li a .alert-date {
    position: absolute;
    right: 10px;
    font-size: 12px;
    color: rgba(73,73,73,0.30);
}

.alerts-none {
    padding: 20px 0px;
    opacity: .6;
}

.alerts-none a {
    color: #000;
}
</style>

